/**
 * EmailInvite
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useApi2fetch } from 'containers/Api2/index.js';
import messages from './messages.js';
import Individual from './Individual.jsx';
import ImportEmails from './ImportEmails.jsx';

function EmailInvite(props) {
  const { roleName, userId, onClose } = props;
  const api2fetch = useApi2fetch();

  async function handleSubmit(users) {
    const count = users.flatMap((o) => o.email).length;
    const url = `sa/users/${roleName}/emailInvite`;
    const options = {
      method: 'POST',
      url,
      version: 2,
      body: { users },
      success: { ...messages.invitationsSent, values: { count } },
    };
    try {
      await api2fetch(options);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
    if (onClose) {
      onClose();
    }
  }

  return userId
    ? <Individual userId={userId} multiple={roleName === 'student'} onSubmit={handleSubmit} />
    : <ImportEmails roleName={roleName} onSubmit={handleSubmit} />;
}

EmailInvite.propTypes = {
  roleName: PropTypes.oneOf(['student', 'employee']).isRequired,
  userId: PropTypes.number,
  onClose: PropTypes.func,
};

export default EmailInvite;
